import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_DBL, GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { GEL_LONG_PRIMER } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import Image from '@bbc/psammead-image';
var NOJS_BACKGROUND_COLOUR = 'rgba(34, 34, 34, 0.75)';
var StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1pnftlt-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
var MessageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "MessageWrapper",
  componentId: "sc-1pnftlt-1"
})(["", " ", ";width:100%;height:100%;position:absolute;top:0;left:0;border:0.0625rem solid transparent;color:", ";background-color:", ";@media screen and (-ms-high-contrast:active){background-color:transparent;}"], function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
}, GEL_LONG_PRIMER, C_WHITE, NOJS_BACKGROUND_COLOUR);
var StyledMessage = /*#__PURE__*/styled.strong.withConfig({
  displayName: "StyledMessage",
  componentId: "sc-1pnftlt-2"
})(["display:block;font-weight:normal;bottom:0;position:absolute;padding:", ";border-bottom:0.0625rem solid transparent;@media screen and (-ms-high-contrast:active){background-color:window;}@media (min-width:", "){padding:", ";}"], GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_SPACING_DBL);

var Message = function Message(_ref2) {
  var service = _ref2.service,
      message = _ref2.message,
      placeholderSrc = _ref2.placeholderSrc,
      placeholderSrcset = _ref2.placeholderSrcset;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, placeholderSrc && /*#__PURE__*/React.createElement(Image, {
    alt: "",
    src: placeholderSrc,
    srcset: placeholderSrcset,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(MessageWrapper, {
    service: service
  }, /*#__PURE__*/React.createElement(StyledMessage, null, message)));
};

Message.propTypes = {
  service: string.isRequired,
  message: string.isRequired,
  placeholderSrcset: string,
  placeholderSrc: string
};
Message.defaultProps = {
  placeholderSrcset: '',
  placeholderSrc: ''
};
export default Message;